import React from "react";
import { ListItem, StarIndicator } from "../../../components";

interface TabItemProps {
  className?: string;
  title: string;
  description: string;
  image: string;
  variant?: "client" | "hero";
  centeredImage?: boolean;
  imgClassName?: string;
}

export const TabItem = ({
  className,
  title,
  description,
  image,
  variant,
  centeredImage,
  imgClassName,
}: TabItemProps) => {
  return (
    <div
      className={`rounded-lg bg-white grid p-4 sm:p-6 gap-4 sm:gap-6 min-w-0 overflow-hidden ${
        className ? className : ""
      }`}
    >
      <div
        className={`min-w-0 ${
          variant === "client" ? "flex" : "grid"
        } gap-4 sm:gap-5`}
      >
        <StarIndicator className="mt-1 sm:mt-4 shrink-0" />
        <ListItem className="min-w-0" title={title} description={description} />
      </div>
      <div
        className={`bg-[#F1F3FB] px-3 sm:px-4 pt-3 sm:pt-4 pb-0 relative min-w-0 w-full overflow-hidden rounded-md flex justify-center ${
          centeredImage ? "items-center" : "items-end"
        } ${
          variant === "hero"
            ? "min-h-[240px] sm:min-h-[320px] lg:min-h-[400px]"
            : "min-h-[200px] sm:min-h-[260px] lg:min-h-[300px]"
        }`}
      >
        <img
          className={`relative max-w-full w-full h-auto object-contain object-bottom ${
            imgClassName ? imgClassName : ""
          }`}
          src={image}
          alt={title}
          loading="lazy"
        />
      </div>
    </div>
  );
};
